import { inject, Injectable, type Provider } from '@angular/core';

import type { LanguageConfig, PhraseAppTranslations } from '@core/i18n-legacy';
import {
  I18N_CONFIG_TOKEN,
  I18nService,
  LANGUAGE_CONFIG,
  LOCALE,
  PHRASE_APP_TRANSLATIONS,
  PhraseAppEditorService,
  PhraseAppTranslationService,
  phraseAppTranslationsLoader,
  TranslationsProvider,
} from '@core/i18n-legacy';
import type { TellentAssistantMobileTranslationSources } from '@core/tellent-assistant-mobile-contracts';

@Injectable({ providedIn: 'root' })
export class TellentAssistantMobileI18nService {
  private translations: PhraseAppTranslations[] | null = null;

  public async load(sources: TellentAssistantMobileTranslationSources): Promise<void> {
    this.translations ??= await phraseAppTranslationsLoader('en', 'en', sources);
  }

  public get loadedTranslations(): PhraseAppTranslations[] {
    return this.translations ?? [];
  }
}

export function buildTellentAssistantMobileI18nProviders(): Provider[] {
  return [
    {
      provide: PHRASE_APP_TRANSLATIONS,
      useFactory: () => inject(TellentAssistantMobileI18nService).loadedTranslations,
    },
    { provide: TranslationsProvider, useExisting: PhraseAppTranslationService },
    { provide: LOCALE, useValue: 'en' },
    { provide: I18N_CONFIG_TOKEN, useValue: { editorEnabled: false, phraseAppProjectId: '' } },
    {
      provide: LANGUAGE_CONFIG,
      useValue: <LanguageConfig>{ defaultLanguage: 'en', languages: ['en'] },
    },
    I18nService,
    PhraseAppTranslationService,
    PhraseAppEditorService,
  ];
}
